"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PromiseEventList = void 0;
const ste_core_1 = require("ste-core");
const PromiseEventDispatcher_1 = require("./PromiseEventDispatcher");
/**
 * Storage class for multiple events that are accessible by name.
 * Events dispatchers are automatically created.
 */
class PromiseEventList extends ste_core_1.EventListBase {
    /**
     * Creates a new EventList instance.
     */
    constructor() {
        super();
    }
    /**
     * Creates a new dispatcher instance.
     */
    createDispatcher() {
        return new PromiseEventDispatcher_1.PromiseEventDispatcher();
    }
}
exports.PromiseEventList = PromiseEventList;
